import { createReducer, createTypes } from 'reduxsauce';

export const segundoNivelTypes = createTypes(
  `
  SET_VALORES_UCHAS_EBAS
  SET_ZONAS
  SET_APLICACOES
  SET_PARQUES
  SET_PARQUE_SELECIONADO
  RESET
  `,
  { prefix: 'SEGUNDO/' }
);

const INITIAL_STATE = {
  mapa: {
    aplicacoes: [],
    parques: [],
  },
  filterStatus: [],
  parqueSelecionado: {},
  clienteSelecionado: null,
  zonaSelecionada: {},
  uchas: {},
  ebas: {},
  conexoes: [],
};

const setUchasEbas = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    uchas: { ...state.uchas, ...action.uchas },
    ebas: { ...state.ebas, ...action.ebas },
    conexoes: action.conexoes || state.conexoes,
  };
};

const setAplicacoes = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    mapa: {
      ...state.mapa,
      clientes: action.clientes,
    },
  };
};

const setParques = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    mapa: {
      ...state.mapa,
      parques: action.parques,
    },
  };
};

const setSelecionados = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    filterStatus: action.filterStatus,
    parqueSelecionado: action.parqueSelecionado || state.parqueSelecionado,
    clienteSelecionado: action.clienteSelecionado || state.clienteSelecionado,
    zonaSelecionada: action.zonaSelecionada || state.zonaSelecionada,
  };
};

const reset = () => {
  return INITIAL_STATE;
};

export default createReducer(INITIAL_STATE, {
  [segundoNivelTypes.SET_VALORES_UCHAS_EBAS]: setUchasEbas,
  [segundoNivelTypes.SET_APLICACOES]: setAplicacoes,
  [segundoNivelTypes.SET_PARQUES]: setParques,
  [segundoNivelTypes.SET_PARQUE_SELECIONADO]: setSelecionados,
  [segundoNivelTypes.RESET]: reset,
});
